export { default as createMutationMixin } from './createMutationMixin'
export { default as toast } from './toasts'

const dateTimeFormat = new Intl.DateTimeFormat(
  navigator.language,
  {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }
)

const dateFormat = new Intl.DateTimeFormat(
  navigator.language,
  {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }
)

export const formatDateTime = (date) => date ? dateTimeFormat.format(new Date(date)) : '-'
export const formatDate = (date) => date ? dateFormat.format(new Date(date)) : '-'

const percentFormat = new Intl.NumberFormat(
  navigator.language,
  {
    style: 'percent',
    maximumFractionDigits: 2
  }
)

export const formatPercent = (percent) => percent ? percentFormat.format(percent) : '-'

const decimalFormat = new Intl.NumberFormat(
  navigator.language,
  {
    style: 'decimal',
  }
)

/**
 * If the currency is a valid ISO 4217 code then the value will be divided by 100 and formatted; otherwise the
 * value will just be formatted as a decimal value.
 */
export const formatMoney = (value, currency) => {
  if (currency === 'COINS') {
    return decimalFormat.format(value)
  } else {
    try {
      const options = getCurrencyFormatOptions(currency)
      return (value / 100).toLocaleString(navigator.language, options)
    } catch (_) {
      return decimalFormat.format(value)
    }
  }
}

/**
 * @throws an error if the currency is unknown
 */
const getCurrencyFormatOptions = (currency) => {
  const {
    minimumFractionDigits,
    maximumFractionDigits
  } = new Intl.NumberFormat(navigator.language, { style: 'currency', currency }).resolvedOptions()
  return {
    minimumFractionDigits,
    maximumFractionDigits
  }
}
